import { InjectionToken } from '@angular/core';
import { AppFeatureKey, AppPagePrinter, AppPagePrinterPayload, AppRoleKey } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface AppPagePrinterApiService {
  postAppPagePrinter(
    payload: AppPagePrinterPayload,
    featureKeys?: AppFeatureKey[],
    roleKeys?: AppRoleKey[],
  ): Observable<AppPagePrinter>;
}
export const APP_PAGE_PRINTER_API_SERVICE_TOKEN = new InjectionToken<AppPagePrinterApiService>(
  'AppPagePrinterApiService',
);
